"use strict";

module.exports = {
  'name': 'sech',
  'category': 'Trigonometry',
  'syntax': ['sech(x)'],
  'description': 'Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)',
  'examples': ['sech(2)', '1 / cosh(2)'],
  'seealso': ['coth', 'csch', 'cosh']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/sech.js
// module id = 973
// module chunks = 0